import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import classNames from 'classnames';

var BVInline = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(BVInline, _React$Component);

  function BVInline() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = BVInline.prototype;

  _proto.render = function render() {
    var _classNames;

    var className = classNames('bv-inline', (_classNames = {}, _classNames["" + this.props.className] = this.props.className, _classNames));
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      "data-bv-show": "inline_rating",
      "data-bv-productid": this.props.productID,
      "data-bv-redirect-url": this.props.redirectUrl
    });
  };

  return BVInline;
}(React.Component);

export { BVInline as default };